import React from "react";
import { useCollection } from "../hooks/useCollection";
import fallback1 from "../assets/img/portfolio/Doc1.jpg";
import fallback2 from "../assets/img/portfolio/Doc2.jpg";
import fallback3 from "../assets/img/portfolio/Doc3.jpg";

const fallbackImgs = [fallback1, fallback2, fallback3];

const Documents = () => {
  const { items, loading } = useCollection("documents", "order", "asc");

  return (
    <section id="documents" className="documents">
      <div className="section-title" data-aos="fade-up">
        <h2>Documents</h2>
        <p>เอกสารและหนังสือของเรา</p>
      </div>
      <div className="container">
        {loading ? (
          <div className="text-center text-muted py-4">กำลังโหลด...</div>
        ) : items.length === 0 ? (
          <div className="text-center text-muted py-4">ยังไม่มีเอกสาร</div>
        ) : (
          <div className="row g-4">
            {items.map((item, idx) => (
              <div className="col-md-4" key={item.id}>
                <div className="card h-100 shadow-sm">
                  <img
                    className="card-img-top a4-image"
                    src={item.imageUrl || fallbackImgs[idx % fallbackImgs.length]}
                    alt={item.title}
                  />
                  <div className="card-body">
                    <h5 className="card-title">{item.title}</h5>
                    {item.summary && (
                      <p className="card-text">{item.summary}</p>
                    )}
                    <span className="card-buttons">
                      {item.link && (
                        <a
                          href={item.link}
                          target="_blank"
                          rel="noreferrer"
                          className="ready-btn"
                        >
                          อ่านทั้งหมด
                        </a>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Documents;
